module.exports = __webpack_public_path__ + "img/login-right-bg.72af4b7b.jpg";